/**
 * Константы и форматтеры эвента «Проклятие Skinoz» (Хэллоуин).
 */

// Постер эвента (4:3) — общий для баннера на главной и героя страницы
export const HALLOWEEN_POSTER = '/images/event/halloween-poster-event.jpg'
export const PUMPKIN_ICON = '/images/event/pumpkin.png'

// Портрет ведьмы — кадр из постера (шляпа и лицо), без отдельного файла
export const WITCH_PORTRAIT_STYLE = {
  backgroundImage: `url(${HALLOWEEN_POSTER})`,
  backgroundSize: '467%',
  backgroundPosition: '60.6% 0%'
}

// Режимы, которые дают тыквы (rules.modes); других значений бэкенд не присылает
export const HALLOWEEN_MODES = ['case', 'upgrader', 'contract', 'crash', 'classic', 'double', 'wheel50', 'casebattle', 'mines']

/**
 * Обратный отсчёт: «5д 07:12:40» или «07:12:40».
 * Моноширинность цифр обеспечивается классом tabular-nums на элементе.
 */
export const formatEventTimer = (seconds, t) => {
  const total = Math.max(0, Math.round(Number(seconds) || 0))
  const days = Math.floor(total / 86400)
  const hours = Math.floor((total % 86400) / 3600)
  const minutes = Math.floor((total % 3600) / 60)
  const secs = total % 60
  const pad = (n) => String(n).padStart(2, '0')
  if (days > 0) return `${days}${t('timeShort.d', 'д')} ${pad(hours)}:${pad(minutes)}:${pad(secs)}`
  return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`
}

/** Разбивка секунд на дни/часы/минуты/секунды для плиток таймера */
export const splitSeconds = (seconds) => {
  const total = Math.max(0, Math.round(Number(seconds) || 0))
  return {
    d: Math.floor(total / 86400),
    h: Math.floor((total % 86400) / 3600),
    m: Math.floor((total % 3600) / 60),
    s: total % 60
  }
}

/**
 * Дата события по таймеру из ответа (секунды до него) в московском времени.
 * shiftSeconds — сдвиг, например -1, чтобы «до 00:00 9 ноября» показать как «8 ноября».
 */
export const formatMoscowDate = (secondsFromNow, language, { shiftSeconds = 0, withTime = false } = {}) => {
  const timestamp = Date.now() + ((Number(secondsFromNow) || 0) + shiftSeconds) * 1000
  return new Intl.DateTimeFormat(language, {
    timeZone: 'Europe/Moscow',
    day: 'numeric',
    month: 'long',
    ...(withTime ? { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' } : {})
  }).format(timestamp)
}
